import * as v from 'valibot';
import { getGraphQLClient } from '@repo/graphql-client';
import { getInternalSupergraphUrl, graphQlRequest } from '@repo/graphql-client/utils';
import { marketplaceEntitySchema } from './schema';
import type { SMBIllustrationCardListMarketplaceEntity } from './types';

export async function getSmbMarketplaceEntity(
  id: string,
): Promise<SMBIllustrationCardListMarketplaceEntity | null> {
  try {
    const gqlClient = getGraphQLClient({ url: getInternalSupergraphUrl() });
    const res = await graphQlRequest<{
      marketplaceEntityV2: SMBIllustrationCardListMarketplaceEntity;
    }>(QUERY_ENTITY, { id }, gqlClient);
    if (res?.marketplaceEntityV2) {
      return v.parse(marketplaceEntitySchema, res.marketplaceEntityV2);
    }
    return null;
  } catch (e) {
    console.log('Error in getSmbMarketplaceEntity', e);
    return null;
  }
}

const QUERY_ENTITY = `
  query SMBIllustrationCardListMarketplaceEntity($id: ID!) {
    marketplaceEntityV2(id: $id) {
      __typename
      id
      status
      name
      productType
      entityType
      ... on BankingOfferV2 {
        monetizable
        cta {
          text
          subtext
          link
          type
        }
        product {
          id
          name
          institution {
            id
            displayName
          }
        }
        reviewLink
      }
    }
  }
`;
